<div class="item cn-up-down">
	<i class="icon audio-mes">
		<goto-ico></goto-ico>
		<span class="counter"><span>{{ node._id_ + 1 }}</span></span>
	</i>
	<div class="name">Переход на действие</div>
</div>